import styled from 'styled-components'
import { PostImageProps } from './postImage.types'

type WrapperProps = {
  $aspectRatio?: PostImageProps['aspectRatio']
  $isEdit?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  margin-top: ${({ $isEdit }) => ($isEdit ? '1.5rem' : '0')};
  position: relative;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || '16/9'};
  overflow: hidden;
  height: ${({ $isEdit }) => ($isEdit ? '7.688rem' : 'auto')};
  border-radius: ${({ $isEdit }) => ($isEdit ? '0.5rem' : '0')};

  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    height: ${({ $isEdit }) => ($isEdit ? '100%' : 'auto')};
    object-fit: cover;
    margin: auto;
  }
`

Wrapper.displayName = 'Wrapper'
